import React, { createContext, FunctionComponent, useState, ReactNode } from "react";

const rowsPerPageOptions = [10, 20, 50, 100, 500];
const defaultRowsPerpage = rowsPerPageOptions[0];

interface IDefaultValues {
  page: number;
  searchTerm: string;
  rowsPerPage: number;
}

enum ListOrgTabs {
  All = 0,
  NotActivated, 
  ExpiredActivation
}

export interface IOrganizationsContext {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  selectedOrg: string | null;
  setSelectedOrg: React.Dispatch<React.SetStateAction<string | null>>;
  selectedCheckedOrgs: string[];
  setSelectedCheckedOrgs: React.Dispatch<React.SetStateAction<string[]>>;
  searchTerm?: string | null;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  ListOrgTabs: any;
  orgListTab: number;
  setOrgListTab: React.Dispatch<React.SetStateAction<number>>;
  rowsPerPage: number;
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>;
  isOrgListLoading: boolean;
  setIsOrgListLoading: React.Dispatch<React.SetStateAction<boolean>>;
  rowsPerPageOptions: number[];
  defaults: IDefaultValues;
}

interface OrganizationsProviderProps {
  children: ReactNode; // This allows any valid React node as a child
}

export const OrganizationsContext = createContext<IOrganizationsContext>(
  {} as IOrganizationsContext
);

export const OrganizationsProvider: FunctionComponent<OrganizationsProviderProps>  = ({ children }) => {
  const [page, setPage] = useState<number>(0);
  const [selectedOrg, setSelectedOrg] = useState<string | null>(null);
  const [selectedCheckedOrgs, setSelectedCheckedOrgs] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOrgListLoading, setIsOrgListLoading] = useState<boolean>(true);
  const [rowsPerPage, setRowsPerPage] = useState<number>(defaultRowsPerpage);
  const [orgListTab, setOrgListTab] = useState( ListOrgTabs.All);

  return (
    <OrganizationsContext.Provider
      value={{
        page,
        setPage,
        selectedOrg,
        setSelectedOrg,
        selectedCheckedOrgs,
        setSelectedCheckedOrgs,
        searchTerm,
        setSearchTerm,
        rowsPerPage,
        setRowsPerPage,
        isOrgListLoading,
        setIsOrgListLoading,
        rowsPerPageOptions,
        defaults: {
          page: 0,
          searchTerm: "",
          rowsPerPage: defaultRowsPerpage,
        },
        ListOrgTabs,
        orgListTab, setOrgListTab
      }}
    >
      {children}
    </OrganizationsContext.Provider>
  );
};

//export const OrganizationsConsumer = OrganizationsContext.Consumer;
